import styled from 'styled-components'
import { createScrollbar } from '../../utils/css'

export const Wrap = styled.div`
  flex: 1;
  ${ createScrollbar() }
`
